import styled from "styled-components";

export const Container = styled.section``;

export const Header = styled.div`
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0 0 30px 0;
  padding: 0 0 30px 0;
  border-bottom: 2px solid #212529;

  .order-num-date {
    width: 80%;
    word-break: keep-all;

    @media only screen and (max-width: 480px) {
      display: flex;
      flex-direction: column;
      width: 70%;
    }

    .content {
      font-size: 16px;

      @media only screen and (min-width: 768px) and (max-width: 1199px) {
        font-size: 15px;
      }

      @media only screen and (min-width: 481px) and (max-width: 767px) {
        font-size: 14px;
        letter-spacing: -0.3px;
      }

      @media only screen and (max-width: 480px) {
        display: none;
      }
    }

    .sm-content {
      @media only screen and (min-width: 480px) {
        display: none;
      }
    }
  }

  .support {
    display: flex;
    justify-content: end;
    align-items: center;

    button {
      padding: 10px 16px;
      border: none;
      border-radius: 5px;
      font-size: 13px;
      color: #ffffff;
    }
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  flex-direction: column;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
`;

export const ProductSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;

  .product-content {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 24px 24px 24px;

    /* @media only screen and (max-width: 767px) {
      padding: 0;
    } */

    :not(:first-child) {
      padding-top: 2rem;
      border-top: 1px solid #ececec;
    }

    .img-section {
      width: 15%;
      min-width: 130px;
      margin-right: 1.5rem;
      display: flex;
      justify-content: center;

      @media only screen and (min-width: 376px) and (max-width: 767px) {
        min-width: 100px;
        /* margin-right: 0.5rem; */
      }

      @media only screen and (max-width: 375px) {
        display: none;
        min-width: 90px;
        /* margin-right: 0.5rem; */
      }
    }

    .info-section {
      width: 55%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #253d4e;
      font-weight: 500;

      @media only screen and (max-width: 767px) {
        width: 100%;
      }

      .info-row {
        display: flex;
        margin-bottom: 0.3rem;

        .content {
          width: 90%;
        }

        .content > .new-tab {
          color: #253d4e;
        }

        .content.product-name {
          width: 90%;
          font-size: 16px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          @media only screen and (min-width: 768px) and (max-width: 992px) {
            width: 85%;
          }

          @media only screen and (max-width: 430px) {
            font-size: 14px;
            width: 85%;
          }
        }

        .content.counts {
          display: flex;
          justify-content: start;

          .strike {
            text-decoration: line-through;
          }
        }
      }

      .btn-section-md {
        display: flex;
        justify-content: start;
        margin-top: 0.6rem;

        .button {
          width: 40%;
          padding: 8px 16px;
          font-weight: 400;

          @media only screen and (max-width: 480px) {
            padding: 8px 0 !important;
            font-size: 13px;
          }

          /* :last-child {
            margin-left: 2rem;
          } */
        }

        @media only screen and (min-width: 768px) {
          display: none;
        }
      }
    }

    .btn-section {
      width: 30%;
      display: flex;
      justify-content: end;
      align-items: center;

      @media only screen and (max-width: 768px) {
        display: none;
      }

      .button {
        padding: 8px 16px;
        font-weight: 400;

        :last-child {
          margin-left: 1rem;
        }
      }
    }
  }
`;

export const DeliverySection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;

  .delivery-header {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 0 30px 0;
    padding: 0 0 30px 0;
    border-bottom: 2px solid #212529;
  }

  .delivery-content {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 24px;

    @media only screen and (max-width: 767px) {
      padding: 0;
    }

    .info-section {
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #253d4e;
      font-size: 16px;

      @media only screen and (max-width: 480px) {
        font-size: 15px;
      }

      .info-row {
        /* width: 100%; */
        display: flex;
        margin-bottom: 1rem;

        :last-child {
          margin-bottom: 0;
        }

        .title {
          min-width: 10rem;
          font-weight: 400;

          @media only screen and (max-width: 480px) {
            min-width: 6rem;
          }
        }

        .content {
          font-weight: 500;
        }
      }
    }
  }
`;

export const PaymentsSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;

  .payments-header {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 0 30px 0;
    padding: 0 0 30px 0;
    border-bottom: 2px solid #212529;
  }

  .payments-content {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 24px;
    margin-bottom: 2rem;

    @media only screen and (max-width: 767px) {
      padding: 0;
    }

    .info-section {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #253d4e;
      font-size: 16px;

      @media only screen and (max-width: 480px) {
        font-size: 15px;
      }

      .info-row {
        /* width: 100%; */
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;

        :last-child {
          margin-bottom: 0;
        }

        .title {
          min-width: 10rem;
          font-weight: 400;

          @media only screen and (max-width: 480px) {
            min-width: 6rem;
          }
        }

        .content {
          font-weight: 500;
        }
      }
    }
  }
`;
